import { NgModule } from '@angular/core';

import { AuthService } from './auth.service';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AngularFirestoreModule } from 'angularfire2/firestore';

import { AuthGuard } from './auth.guard';
import { AdminGuard } from './admin.guard';
import { EditorGuard } from './editor.guard';

@NgModule({
  imports: [
    AngularFireAuthModule,
    AngularFirestoreModule
  ],
  providers: [AuthService, AuthGuard, AdminGuard, EditorGuard],
  declarations: []

})
export class CoreModule {}



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts